import JwtService from "../../../utils/jwt.service";

export default {
  set_error(state, error) {
    state.errors = error;
    state.message = [];
    for (const field in error) {
      if ({}.propertyIsEnumerable.call(error, field)) {
        const msg = error[field];
        state.message.push(field + " " + msg[0]);
      }
    }
  },
  set_auth(state, token) {
    state.isAuthenticated = true;
    JwtService.saveToken(token);
  },
  set_price(state,price){
    state.price = price
  },
  set_credit(state,credit){
    state.credit = credit
  },
  set_open_order(state, order){
    if(order){
      state.hasOpenInvoice=true;
    }
  },
  set_user(state, user) {
    state.user = user;
  },
  set_client(state, client) {
    state.client = client;
  },
  set_address(state, address) {
    state.address = address;
  },
  purge_auth(state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = null;
    JwtService.destroyToken();
  },
  fetch_end(state, { billings, billingsCount }) {
    state.billings = billings;
    state.billingsCount = billingsCount;
    state.isLoading = false;
  },
  set_loading(state, loading) {
    state.loading = loading;
  },
  clearMessage(state) {
    state.message = [];
  }
};
